<div style="position: absolute" class="h-full w-full flex items-center justify-center shell-page-background">
    <section style="padding: 24px 32px 32px 32px; border-radius: 4px; max-width: 400px" class="mat-elevation-z2 flex flex-col">
        <div style="margin-bottom: 16px" class="flex gap-4 items-center">
            <img alt="RaxBooker icoon" src="./assets/img/raxbooker_icon_32.png" />
            <h1 style="font-weight: normal">Rax<span style="font-weight: bold">Booker</span></h1>
        </div>
        <h3 style="margin: 0">U bent uitgelogd</h3>

        <p>Bedankt,<br />Sluit dit browser venster of log opnieuw in.</p>

        <button mat-raised-button (click)="onLogInAgainButtonClick()" style="margin-top: 16px">Log opnieuw in</button>
    </section>
</div>
